import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewCategory() {
  const location = useLocation();
  const incomingData = location.state.data;

  const [data, setData] = useState([]);
  const [subCatg, setSubCatg] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mealtypes, setMealtypes] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate(null);

  useEffect(() => {
    getProducts();
    getSubCategories();
    getAccessories();
    getMealTyps();
  }, []);

  // Fetching Data
  const getProducts = async () => {
    setLoading(true);
    console.log("get Prodcut Called");
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/product/by-category?searchId=${id}`,
        {
          headers: headers,
        }
      );

      console.log("Response", response);
      setData(response.data.result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getSubCategories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/subCategory/by-categoryId/${id}`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        console.log("Response", response);
        setSubCatg(response.data.result.subCategories);
      } else {
        // toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getAccessories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const formdata = new FormData();
      formdata.append("categoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/accessory/get-accessories-by-category`,
        formdata,
        {
          headers: headers,
        }
      );
      console.log("Response", response);
      setAccessories(response?.data?.result?.accessories);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getMealTyps = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/mealtype/by-type/${id}`,
        {
          headers: headers,
        }
      );
      console.log("Response", response);
      setMealtypes(response?.data?.result?.types);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };


  const deleteSubCategory = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("subCategoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/subCategory/delete-subCategory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getSubCategories();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit sub category. Please try again.", error);
    }
  };

  const deleteProduct = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("productId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/product/delete-product`,
        formdata,
        { headers }
      );
      console.log("Prodcuts Response delete", response);
      await getProducts();
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete product. Please try again.", error);
    }
  };

  const deleteAccessory = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("accessoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/accessory/delete-accessory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getAccessories();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit accessory. Please try again.", error);
    }
  };


  const deleteMealType = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("typeId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/mealtype/delete-type`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getMealTyps();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete meal type. Please try again.", error);
    }
  };


  return (
    <div>
      <Layout>
        <ToastContainer />
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Category</h2>

            {["tiffin service"].includes(incomingData?.name?.toLowerCase()) && (
              <button
                onClick={() => {
                  navigate(`/admin-panel/delivery-times/edit`, {});
                }}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Update Delivery Timing
              </button>
            )}

           <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>


          </div>
          <div className="mt-10">
            <div className="my-6">
              <img
                src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${incomingData.image}`}
                className="h-[100px] w-[100px] rounded-full border-2"
                alt=""
              />
            </div>
          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Category</h6>
                <p className="mt-1">{incomingData?.name?.toUpperCase()}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Title</h6>
                <p className="mt-1">{incomingData.title}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Description</h6>
                <p className="mt-1">{incomingData.description}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Commission Amount</h6>
                <p className="mt-1">{incomingData?.commissionAmount}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{incomingData.status}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(incomingData.createdAt)}</p>
              </div>
            </div>
          </div>

          {/* Sub Category */}

          {incomingData?.name}

          {["laundry"].includes(incomingData?.name?.toLowerCase()) && (
            <div>
              <div className="flex justify-between items-center mt-20 ">
                <h2 className="text-lg font-medium">View Sub Categories</h2>
                <div className="">
                  <button
                    className="border py-2 px-2 rounded-md text-sm !outline-none"
                    onClick={() => {
                      navigate(`/admin-panel/sub-category/add/${id}`);
                    }}
                  >
                    Add Sub Category
                  </button>
                </div>
              </div>

              <div className="mt-6">
                <div className="flex gap-4 justify-between flex-wrap mt-10">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b">
                        <td className="font-medium py-4 cursor-pointer">
                          Product Name{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Created At{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Status{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Actions{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading ? (
                        subCatg?.length > 0 ? (
                          subCatg?.map((item) => (
                            <tr key={item._id} className="border-b">
                              <td className="py-3 text-sm">{item.name}</td>
                              <td className="py-3 text-sm">
                                {formatDate(item.createdAt)}
                              </td>
                              <td className="py-3 text-sm">{item.status}</td>
                              <td className="py-3 text-sm flex justify-center gap-x-3">
                                <button
                                  className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                  title="View Sub Category"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/sub-category/view/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                  title="Edit Sub Category"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/sub-category/edit/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-danger rounded-full"
                                  title="Delete Sub Category"
                                  onClick={() => {
                                    deleteSubCategory(item?._id);
                                  }}
                                >
                                  <i className="fa fa-trash text-white"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td colSpan={4} className="text-center">
                            <p className="text-center w-full mt-10">
                              No results found
                            </p>
                          </td>
                        )
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            Loading ...
                          </p>
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* products */}
          {!["tiffin service","meals & snacks","laundry"].includes(incomingData?.name?.toLowerCase()) && (
            <div className="mt-6">
              <div className="flex justify-between items-center mt-20 ">
                <h2 className="text-lg font-medium">View Products</h2>
                <div className="">
                  <button
                    className="border py-2 px-2 rounded-md text-sm !outline-none"
                    onClick={() => {
                      navigate(`/admin-panel/product/add/${id}`);
                    }}
                  >
                    Add Product
                  </button>
                </div>
              </div>

              {/* Products Listing */}
              <div className="mt-6">
                <div className="flex gap-4 justify-between flex-wrap mt-10">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b">
                        <td className="font-medium py-4 cursor-pointer">
                          Product Name{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Created At{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Status{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Actions{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading ? (
                        data?.length > 0 ? (
                          data?.map((item) => (
                            <tr key={item._id} className="border-b">
                              <td className="py-3 text-sm">{item.name}</td>
                              <td className="py-3 text-sm">
                                {formatDate(item.createdAt)}
                              </td>
                              <td className="py-3 text-sm">{item.status}</td>
                              <td className="py-3 text-sm flex justify-center gap-x-3">
                                <button
                                  className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                  title="View Category"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/product/view/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                  title="Edit Product"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/product/edit/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-danger rounded-full"
                                  title="Delete Product"
                                  onClick={() => {
                                    deleteProduct(item?._id);
                                  }}
                                >
                                  <i className="fa fa-trash text-white"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td colSpan={4} className="text-center">
                            <p className="text-center w-full mt-10">
                              No results found
                            </p>
                          </td>
                        )
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            Loading ...
                          </p>
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {["water", "oxygen"].includes(incomingData?.name?.toLowerCase()) && (
            <div className="mt-6">
              <div className="flex justify-between items-center mt-20 ">
                <h2 className="text-lg font-medium">View Accessories</h2>
                <div className="">
                  <button
                    className="border py-2 px-2 rounded-md text-sm !outline-none"
                    onClick={() => {
                      navigate(`/admin-panel/accessory/add/${id}`, {
                        state: { data: incomingData?.name },
                      });
                    }}
                  >
                    Add Accessory
                  </button>
                </div>
              </div>

              <div className="mt-6">
                <div className="flex gap-4 justify-between flex-wrap mt-10">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b">
                        <td className="font-medium py-4 cursor-pointer">
                          Name{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Created At{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Status{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Actions{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading ? (
                        accessories?.length > 0 ? (
                          accessories?.map((item) => (
                            <tr key={item._id} className="border-b">
                              <td className="py-3 text-sm">{item.name}</td>
                              <td className="py-3 text-sm">
                                {formatDate(item.createdAt)}
                              </td>
                              <td className="py-3 text-sm">{item.status}</td>
                              <td className="py-3 text-sm flex justify-center gap-x-3">
                                <button
                                  className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                  title="View Accessory"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/accessory/view/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                  title="Edit Accessory"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/accessory/edit/${item._id}`,
                                      {
                                        state: {
                                          data: item,
                                          name: incomingData?.name,
                                        },
                                      }
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-danger rounded-full"
                                  title="Delete Accessory"
                                  onClick={() => {
                                    deleteAccessory(item._id);
                                  }}
                                >
                                  <i className="fa fa-trash text-white"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td colSpan={4} className="text-center">
                            <p className="text-center w-full mt-10">
                              No results found
                            </p>
                          </td>
                        )
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            Loading ...
                          </p>
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {["meals", "meals & snacks"].includes(incomingData?.name?.toLowerCase()) && (
            <div className="mt-6">
              <div className="flex justify-between items-center mt-20 ">
                <h2 className="text-lg font-medium">Meal Type</h2>
                <div className="">
                  <button
                    className="border py-2 px-2 rounded-md text-sm !outline-none"
                    onClick={() => {
                      navigate(`/admin-panel/mealtype/add/${id}`, {
                        state: { data: incomingData?.name },
                      });
                    }}
                  >
                    Add Meal Type
                  </button>
                </div>
              </div>

              <div className="mt-6">
                <div className="flex gap-4 justify-between flex-wrap mt-10">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b">
                        <td className="font-medium py-4 cursor-pointer">
                          Name{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Created At{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Status{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Actions{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading ? (
                        mealtypes?.length > 0 ? (
                          mealtypes?.map((item) => (
                            <tr key={item._id} className="border-b">
                              <td className="py-3 text-sm">{item.title}</td>
                              <td className="py-3 text-sm">
                                {formatDate(item.createdAt)}
                              </td>
                              <td className="py-3 text-sm">{item.status}</td>
                              <td className="py-3 text-sm flex justify-center gap-x-3">

                                <button
                                  className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                  title="View Meal Type"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/mealtype/view/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye text-white"></i>
                                </button>

                                <button
                                  className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                  title="Edit Meal Type"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/mealtype/edit/${item._id}`,
                                      {
                                        state: {
                                          data: item,
                                          name: incomingData?.name,
                                        },
                                      }
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-danger rounded-full"
                                  title="Delete Meal Type"
                                  onClick={() => {
                                    deleteMealType(item._id);
                                  }}
                                >
                                  <i className="fa fa-trash text-white"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td colSpan={4} className="text-center">
                            <p className="text-center w-full mt-10">
                              No results found
                            </p>
                          </td>
                        )
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            Loading ...
                          </p>
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

        </div>
      </Layout>
    </div>
  );
}
